import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { ToolFormValues } from "@/types";
import { CategoryAutocomplete } from "../CategoryAutocomplete";

interface CategoriesSectionProps {
  form: UseFormReturn<ToolFormValues>;
}

export const CategoriesSection = ({ form }: CategoriesSectionProps) => {
  return (
    <FormField
      control={form.control}
      name="categories"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-lg font-semibold text-gray-900">التصنيفات</FormLabel>
          <FormControl>
            <CategoryAutocomplete
              value={field.value}
              onChange={field.onChange}
            />
          </FormControl>
          <FormMessage className="text-red-500 text-sm" />
        </FormItem>
      )}
    />
  );
};